var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDatabaseSolidIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 2V14H13V2H3ZM4 3H12V5.5H4V3ZM4 6.5H12V9.5H4V6.5ZM4 10.5H12V13H4V10.5Z",
    fill: "#303335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatabaseSolidIcon);
export default __webpack_public_path__ + "static/media/databaseSolidIcon.0dfe6689fb26eb7ee4d4e0e7f46f6584.svg";
export { ForwardRef as ReactComponent };